export enum CandidateOfferNoteCategory {
    ClientFacing = 1,
    NonClientFacing = 2
}
